/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ detail: NonNullable<unknown> }} Byoa_Test_FailInputs */

const en_byoa_test_fail = /** @type {(inputs: Byoa_Test_FailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Not connected yet: ${i?.detail}`)
};

const id_byoa_test_fail = /** @type {(inputs: Byoa_Test_FailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Belum tersambung: ${i?.detail}`)
};

/**
* | output |
* | --- |
* | "Not connected yet: {detail}" |
*
* @param {Byoa_Test_FailInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_test_fail = /** @type {((inputs: Byoa_Test_FailInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Test_FailInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_test_fail(inputs)
	return en_byoa_test_fail(inputs)
});